<script setup>
  import { ref, computed, onBeforeMount } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useConfigsStore } from "@/stores/configs";

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const configsStore = useConfigsStore();
  const companyId = useCompanyStore().companyId;

  let id = ref(null);
  let name = ref(null);
  let isSubmitted = ref(false);
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);

  const onSubmit = () => {
    isSubmitted.value = true;
    configsStore.deleteConfig({id : id.value, companyId })
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalAction.value == 'delete_config'){
        id.value = getModalInfo.value.id;
        name.value = getModalInfo.value.name;
    }
  });
</script>
<template>
  <DModal v-if="getModalAction === 'delete_config'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete Configuration </template>
    <template #body>
      <div class="delete-text">
        <span>Are you sure you want to <b>"Delete"</b> the config <b>{{ name }}</b> ?</span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-danger add-button mr-30" >
            Delete <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  